export const AUTH_TOKEN_KEY = 'token'
export const ORDERBOOK_TIMEOUT = 10000
export const TICKS_LIMIT = 14800
export const UPDATE_DATA_DELAY = 5000
export const UPDATE_DEX_CHARTS_DELAY = 5000
export const AVAILABLE_EXCHANGES = [
  {
    title: 'Gate',
    value: 'gate',
  },
  {
    title: 'Mexc',
    value: 'mexc',
  },
  {
    title: 'Ourbit',
    value: 'ourbit',
  },
  {
    title: 'Xt',
    value: 'xt',
  },
  {
    title: 'Weex',
    value: 'weex',
  },
  {
    title: 'Toobit',
    value: 'toobit',
  },
  {
    title: 'LBank',
    value: 'lbank',
  },
  {
    title: 'DyDx',
    value: 'dydx',
  },
  {
    title: 'KuCoin',
    value: 'kucoin',
  },
  {
    title: 'BingX',
    value: 'bingx',
  },
  {
    title: 'BitGet',
    value: 'bitget',
  },
  {
    title: 'Coinex',
    value: 'coinex',
  },
  {
    title: 'ByBit',
    value: 'bybit',
  },
  {
    title: 'Binance',
    value: 'binance',
  },
  {
    title: 'BloFin',
    value: 'blofin',
  },
  {
    title: 'Bitrue',
    value: 'bitrue',
  },
  {
    title: 'Phemex',
    value: 'phemex',
  },
  {
    title: 'Paradex',
    value: 'paradex',
  },
  {
    title: 'Poloniex',
    value: 'poloniex',
  },
  {
    title: 'Bitmart',
    value: 'bitmart',
  },
  {
    title: 'OkX',
    value: 'okx',
  },
  {
    title: 'HTX',
    value: 'htx',
  },
  {
    title: 'Hyperliquid',
    value: 'hyperliquid',
  },
  {
    title: 'Aster',
    value: 'aster',
  },
  {
    title: 'Bitunix',
    value: 'bitunix',
  },
  {
    title: 'Lighter',
    value: 'lighter',
  },
  {
    title: 'Edgex',
    value: 'edgex',
  },
]

export const AVAILABLE_DEXCHANGES = AVAILABLE_EXCHANGES

export const FALLBACK_API_ERROR = {
  message: { detail: [{ type: 'unexpected_error' }] },
  code: -255,
}
export const MAIN_ROUTER_PAGE = {
  name: 'events',
}
export const LOGIN_ROUTER_PAGE = {
  name: 'login',
}
export const AVAILABLE_SWAP_EXCHANGES = [
  'gate',
  'mexc',
  'ourbit',
  'lbank',
  'bingx',
  'bitget',
  'kucoin',
  'hyperliquid',
  'binance',
  'bybit',
  'aster',
  'bitrue',
]
export const AVAILABLE_SPOT_EXCHANGES = [
  'gate',
  'mexc',
  // 'lbank',
  'bingx',
  'bitget',
  'kucoin',
  'binance',
  'bybit',
  'bitrue',
]
export const DEX_CEX_EXCHANGES = ['mexc']
export const DEX_CEX_PRO_EXCHANGES = [
  'gate',
  'mexc',
  'bingx',
  'bitget',
  'lbank',
  'ourbit',
  'kucoin',
  'bybit',
  'binance',
  'aster',
  'hyperliquid',
  'bitrue',
  '1inch',
  'jupiter',
]
export const CEX_EXCHANGES = [
  'mexc',
  'ourbit',
  'gate',
  'bybit',
  'binance',
  'kucoin',
  'bingx',
  'bitget',
  'aster',
  'lbank',
  'hyperliquid',
  'bitrue',
]
export const AVAILABLE_EXCHANGES_LIST = AVAILABLE_EXCHANGES.map((x) => x.value)
export const FUNDING_GROUP_EXCHANGES = AVAILABLE_EXCHANGES_LIST
export const TOAST_LIFE = 20000
export const AVAILABLE_MARKET_TYPES = ['spot-swap', 'swap-swap', 'swap', 'spot', 'swap-spot']
export const CEX_CEX_MARKET_TYPES = ['spot-swap', 'swap-swap', 'swap', 'spot', 'swap-spot']

// Биржи где торги идут не контрактами, а монетами
export const NON_CONTRACT_EXS = ['bitget', 'bingx', 'binance', 'bybit', 'lbank', 'bitrue']

export const SOL_USDT_ADDRESS = 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB'

export const STABLE_ADDRESSES: Record<string, string> = {
  eth: '0xdac17f958d2ee523a2206206994597c13d831ec7',
  bsc: '0x55d398326f99059ff775485246999027b3197955',
  base: '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
}

export const CHAIN_RPCS: Record<string, string[]> = {
  eth: ['https://ethereum-rpc.publicnode.com'],
  bsc: ['https://bsc-rpc.publicnode.com'],
  base: ['https://base-rpc.publicnode.com'],
  // monad: ['https://rpc3.monad.xyz'],
}
export const AVAILABLE_GMGN_CHAINS = ['ETH', 'BSC', 'SOL', 'BASE', 'MONAD']
export const OHLCV_TF = 60

export const QUOTE_TYPES = [
  { label: 'USDT', value: 'USDT' },
  { label: 'USDC', value: 'USDC' },
  { label: 'USD1', value: 'USD1' },
  { label: 'BUSD', value: 'BUSD' },
]
